<template>
  <div class="confirm">
    <Loading v-show="loading" />
    <div class="bg_white mt12 pt16 pb16 boxs1">
      <div class="mb20" v-for="(value, l) in cartItems" :key="l">
        <h2 class="content_title">購入BC</h2>
        <div class="pl16 pr16 mt24">
          <h3 class="nowBC rb c5a bdb">BC：<span class="bc_number rb">{{ value.bcNo }}</span></h3>
        </div>
        <div class="select_item bdb" v-for="(item, m) in value.bcItemList" :key="m">
          <div class="image_wrap">
            <div class="select_image">
              <img :src="imagePath + item.product.imagePath" :alt="item.product.productName" v-on:error="imageError" :data-noimage="imagePath + item.product.noImagePath">
            </div>
            <p class="select_item--title ab c5a">{{ item.product.productName }}</p>
          </div>
          <div class="select_contents">
            <div class="subscription_wrap bdb">
              <h2 class="sub_title ab c5a">定期購入</h2>
              <div class="sub_count">
                <p class="count ab c5a">数量</p>
                <p class="number rb c5a">{{ item.orderCount }}</p>
              </div>
            </div>
            <div class="kodomo_text ab">こども基金：<span class="">{{ (item.childFund) ? '支援する' : '支援しない' }}</span></div>
            <div class="select_price">
              <p class="item_price rm c5a"><span class="yen ab">￥</span>{{ item.childFund ? ((item.product.price * item.orderCount) + (100 * item.orderCount)).toLocaleString() : (item.product.price * item.orderCount).toLocaleString() }}</p>
              <p class="item_point rm c5a"><span class="point_text ab">ポイント：</span>{{ (item.product.point * item.orderCount).toLocaleString() }}<span class="point ab">pt</span></p>
            </div>
          </div>
        </div>
      </div>
      <div class="edit_wrap confirm_coupon pr25">
        <router-link :to="{ name: 'multiSubSelectProducts' }" class="edit btn_yellow btn_mini">編集</router-link>
      </div>
    </div>

    <div class="sum_total bg_white mt12 pt16 pb16">
      <a href="#" class="complete btn_blue" @click.stop.prevent="completeOrder()">確定</a>
      <router-link class="btn_delete back_btn" :to="{ name: 'multiShippingPlan' }">戻る</router-link>
    </div>
    <ErrorModal v-show="isModalOpen" :errorMessage="errorMessage" @modalClose="modalClose" />
  </div>
</template>

<script>
import Loading from '@/components/common/Loading'
import ErrorModal from '@/components/common/ErrorModal'
import RepeatOrder from '@/components/api/repeatOrder'
import Config from '@/config/config'
import scrollPosition from '@/model/scrollPosition';
import { mapGetters } from 'vuex';

export default {
  props: [],
  components: {
    Loading,
    ErrorModal,
  },
  data() {
    return {
      isModalOpen: false,
      errorMessage: '定期購入更新',
      imagePath: Config.APIURL,
      loading: false,
      cartItems: [],
      totalPrice: 0,
      totalPoint: 0
    }
  },
  methods: {
    imageError(e) {
      e.target.src = e.target.dataset.noimage;
    },
    itemList () {
      // 既存のローカルストレージからの読み込み
      let items = JSON.parse(localStorage.getItem('recommendationRepeatItemList'));

      if (items) {
        for (var i = 0; i < items.length; i++) {
          var cartItem = {
            bcNo: items[i].bcNo,
            bcItemList: []
          };
          var bcItemList = items[i].bcItemList;

          for (var j = 0; j < bcItemList.length; j++) {
            var itemList = bcItemList[j].itemList;

            for (var k = 0; k < itemList.length; k++) {
              if (itemList[k].repeatOrder) {
                cartItem.bcItemList.push(itemList[k]);
              }
            }
          }
          this.cartItems.push(cartItem);
        }
      }

      // Vuexから推奨商品データを取得（既存データがない場合）
      if (this.cartItems.length === 0) {
        this.loadRecommendProducts();
      }

      this.calculateTotals();
    },
    loadRecommendProducts() {
      const recommendProducts = this.recommendationRecommendProductMap;

      if (recommendProducts && Object.keys(recommendProducts).length > 0) {
        for (const bcNo in recommendProducts) {
          if (recommendProducts[bcNo].repeatOrdersList) {
            const cartItem = {
              bcNo: bcNo,
              bcItemList: recommendProducts[bcNo].repeatOrdersList
            };
            this.cartItems.push(cartItem);
          }
        }
      }
    },
    calculateTotals() {
      this.totalPrice = 0;
      this.totalPoint = 0;

      for (var i = 0; i < this.cartItems.length; i++) {
        for (var j = 0; j < this.cartItems[i].bcItemList.length; j++) {
          var bcItem = this.cartItems[i].bcItemList[j];
          let totalPrice = bcItem.product.price * bcItem.orderCount;
          let totalPoint = bcItem.product.point * bcItem.orderCount;
          this.totalPrice = this.totalPrice + totalPrice;
          this.totalPoint = this.totalPoint + totalPoint;
          if (bcItem.childFund) {
            this.totalPrice = this.totalPrice + (100 * bcItem.orderCount);
          }
        }
      }
    },
    async completeOrder() {
      this.loading = true;

      try {
        const multiBcOrderData = this.recommendationMultiBcOrderData;

        if (multiBcOrderData && Object.keys(multiBcOrderData).length > 0) {
          // API仕様に従ってリクエストデータを構築
          // simulateMonthlyと同じフォーマットを使用
          const requestData = {
            bcRepeatOrderMap: multiBcOrderData
          };

          // 新しい複数BC定期購入作成API呼び出し（simulateMonthlyと同じリクエストフォーマット）
          const response = await RepeatOrder.createMultipleBcRepeatOrder(requestData);

          this.loading = false;

          if (response.resultStatus === 'OK') {
            // 定期便注文完了時にlocalStorageから購入設定をクリア
            localStorage.removeItem('recommendationPurchaseSettings');
            this.$store.commit('setRecommendationPurchaseSettings', {
              deliveryTimeId: null,
              paymentMethodId: null
            });

            this.$router.push({ path: '/repeatOrder/multiBc/complete' });
          } else if (response.resultStatus === 'SOME_NG') {
            // 一部のBCで失敗
            this.errorMessage = `一部のBCで定期購入の作成に失敗しました。\n成功: ${response.successBcList.join(', ')}\n失敗: ${response.failureBcList.join(', ')}`;
            this.modalOpen();
          } else {
            // すべて失敗
            this.errorMessage = response.errorMessage || '定期購入の作成に失敗しました。';
            this.modalOpen();
          }
        } else {
          this.errorMessage = '注文データが見つかりません。';
          this.modalOpen();
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        this.errorMessage = '予期しないエラーが発生しました。';
        this.modalOpen();
        console.error('定期購入作成エラー:', error);
      }
    },
    modalOpen() {
      scrollPosition.open();
      this.isModalOpen = true;
    },
    modalClose() {
      scrollPosition.close();
      this.isModalOpen = false;
    }
  },
  computed: mapGetters([
    'checkSelectRepeatOrder',
    'recommendationRecommendProductMap',
    'recommendationMultiBcOrderData'
  ]),
  created () {
    this.itemList();
  },
};
</script>

<style lang="css" scoped>
.sameWithBc {
  /* color: red; */
  /* font-size: 13px; */
  font-size: 15px;
}
.select_item {
  border-bottom: 1px solid  #c9c9c9;
  display: flex;
  justify-content: space-between;
  padding: 10px 15px 15px 30px;
}
.image_wrap {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 33%;
}
.month_item {
  display: flex;
  margin-top: 16px;
}
.select_item--title {
  font-size: 12px;
  margin-top: 5px;
}

.subscription_wrap {
  display: flex;
  justify-content: space-between;
}
.subscription_wrap .sub_title {
  font-size: 16px;
}
.subscription_wrap .sub_count {
  align-items: center;
  display: flex;
}

.subscription_wrap .count {
  font-size: 12px;
}

.subscription_wrap .number {
  font-size: 20px;
  margin-left: 27px;
}
.kodomo_text {
  display: flex;
  font-size: 12px;
  justify-content: flex-end;
  margin-top: 18px;
}
.select_price {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  margin-top: 11px;
}

.content_title {
  margin-top: 12px;
  width: 221px;
}
.content_title.delyvery_flag {
  width: 260px;
}

.selsct_bc {
  font-size: 20px;
  margin-top: 9px;
  padding-left: 8px;
  position: relative;
}
.selsct_bc::before {
  background-color: #4FCCD4;
  bottom: 0;
  content: '';
  height: 25px;
  left: 0;
  margin: auto;
  position: absolute;
  top: 0;
  width: 4px;
}

.item_price {
  font-size: 26px;
}

.item_point {
  font-size: 16px;
}

.select_contents {
  margin-top: 60px;
  width: 59%;
}

.content_title {
  width: 140px;
}
.content_title.sum {
  width: 120px;
}

.bc_wrap .bc_number {
  font-size: 20px;
  margin-top: 15px;
  padding-bottom: 5px;
}
.bc_wrap .item_wrap {
  -ms-align-items: flex-start;
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
}
.bc_wrap .item_contents {
  width: 31%;
}

.bc_wrap .item_image {
  margin: auto;
  width: 90%;
}

.bc_wrap .item_title {
  font-size: 12px;
  margin-top: 10px;
  text-align: center;
}

.bc_wrap .contents_detail {
  width: 57.4%;
}

.bc_wrap .count_wrap {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.bc_wrap .month {
  font-size: 24px;
}

.bc_wrap .month_text {
  font-size: 16px;
  margin-left: 2px;
}

/* .bc_wrap .count {
  font-size: 26px;
} */

/* .bc_wrap .count_text {
  font-size: 14px;
  margin-right: 19px;
} */

.bc_wrap .child_wrap {
  align-items: center;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  margin-top: 22px;
}

.bc_wrap .price_wrap {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  margin-top: 25px;
}

.bc_wrap .price {
  font-size: 26px;
}

.bc_wrap .yen {
  font-size: 20px;
}
.bc_wrap .point {
  font-size: 16px;
}
.bc_wrap .point_text {
  font-size: 12px;
}
.bc_wrap .pt {
  font-size: 14px;
}

.confirm_wrap {
  align-items: flex-end;
  /* border-bottom: 1px solid #C9C9C9; */
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding-bottom: 8px;
}
.edit {
  letter-spacing: 7.5px;
  margin: 0;
  text-indent: 7.5px;
}
.confirm_data {
  color: #5a5a5a;
  font-size: 16px;
  line-height: 1;
}
.data_wrap {
  margin-top: 14px;
}
.data_contents {
  font-size: 14px;
  line-height: 1;
  margin-top: 10px;
}

.count {
  font-size: 20px;
  margin-left: 25px;
}

.confirm_address .confirm_wrap {
  margin-top: 27px;
}
.confirm_credit .confirm_wrap {
  margin-top: 24px;
}


.sum_wrap {
  margin-top: 25px;
  padding: 0 15px;
}
.sum_contents {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.sum_contents:last-child {
  border-bottom: 1px solid #C9C9C9;
  padding-bottom: 13px;
}
.sum_title {
  font-size: 14px;
}
.yen {
  font-size: 12px;
}
.sum_price {
  font-size: 16px;
}

.sum_total {
  padding-bottom: 48px;
}
.total_wrap {
  color: #009FA9;
  margin-top: 16px;
  text-align: right;
}

.total_wrap .total_price {
  font-size: 26px;
}

.total_wrap .yen {
  font-size: 20px;
}

.total_wrap .total_point {
  font-size: 12px;
  margin-top: 3px;
}
.total_wrap .point_score {
  font-size: 16px;
}
.total_wrap .point {
  font-size: 12px;
}
.complete {
  margin-top: 56px;
}

.confirm_coupon .edit {
  margin: 16px 0 0 auto;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.select_time_text {
  font-size: 12px;
  color: #009FA9;
  text-align: right;
}

</style>



// WEBPACK FOOTER //
// src/views/subscriptionMultiBc/SubConfirm.vue